import React from 'react'
import moment from 'moment'
import { ChevronRight, Divide } from 'lucide-react'
import { Divider } from '@mui/material'


export const SubscriptionBox = ({ subscription }) => {
    const {
        SubscriptionPriceInfo: {
            SubjectInfo,
            StandardInfo,
            SemesterInfo
        },
        startDate,
        expiryDate
    } = subscription

    return (
        <div className="bg-white rounded-lg shadow-md p-4 mb-4 font-medium">
            <div className="flex justify-between items-start mb-2">
                <h2 className="text-base md:text-lg font-semibold">{SubjectInfo?.subject}</h2>
                <p className="text-sm text-gray-600">Purchase Date: {moment(startDate)?.format('DD-MM-YYYY')}</p>
            </div>
            <div className="flex justify-between mb-2">
                <p className="text-sm">Board: {StandardInfo?.boardInfo?.board_name}</p>
                <p className="text-sm">Medium: {StandardInfo?.mediumInfo?.name}</p>
            </div>
            <div className="flex justify-between mb-4">
                <p className="text-sm">Standard: {StandardInfo?.name}</p>
                <p className="text-sm">{SemesterInfo?.semester}</p>
            </div>
            <Divider style={{ margin: '10px 0px' }} />
            <p className="text-center text-green-600">Expiry Date: {moment(expiryDate)?.format('DD-MM-YYYY')}</p>
        </div>
    )
}

export const QuestionReporyBox = ({ questionData, handleReportDetailsModel }) => {
    return (
        <div className="bg-white rounded-lg shadow-md p-4 mb-4 font-medium">
            <div className="flex justify-between items-start mb-2">
                <h2 className="text-base md:text-lg font-semibold">{questionData?.question?.SubjectInfo?.subject}</h2>
                <ChevronRight className="w-5 h-5 text-gray-400" onClick={() => handleReportDetailsModel(questionData)} />
            </div>
            <div className="flex justify-between items-start mb-2">
                <h2 className="text-base md:text-lg font-semibold">Board:{questionData?.question?.StandardInfo?.boardInfo?.name}</h2>
                <p className="text-sm text-gray-600">Reported Date: {moment(questionData?.createdAt)?.format('DD-MM-YYYY')}</p>
            </div>
            <div className="flex justify-between mb-2">
                <p className="text-sm">Standard: {questionData?.question?.StandardInfo?.name}</p>
                <p className="text-sm">{moment(questionData?.createdAt)?.format('HH:mm:ss')}</p>
            </div>
            <div className="flex justify-between mb-4">
                <p className="text-sm">Type: {questionData?.type}</p>
                <p className="text-sm">Medium: {questionData?.question?.StandardInfo?.mediumInfo?.name}</p>
            </div>
            <div className="flex justify-between mb-4">
                <p className="text-sm">Description: {questionData?.description}</p>
                <p className="text-sm">{questionData?.question?.SemesterInfo?.semester}</p>
            </div>
            <Divider style={{ margin: '10px 0px' }} />
            <p className="text-center text-green-600">{questionData?.status}</p>
        </div>
    )
}

